(() => {
  const sectionSelector = '[data-landing-b2b-professional-tabs]';
  const tabSelector = '[data-landing-b2b-professional-tabs-tab]';
  const panelSelector = '[data-landing-b2b-professional-tabs-panel]';

  const activateTab = (section, tab) => {
    const tabs = Array.from(section.querySelectorAll(tabSelector));
    const panels = Array.from(section.querySelectorAll(panelSelector));
    const targetPanelId = tab.getAttribute('aria-controls');

    tabs.forEach((item) => {
      const isActive = item === tab;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === targetPanelId;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.landingB2bProfessionalTabsInitialized === 'true') {
      return;
    }

    const tabs = Array.from(section.querySelectorAll(tabSelector));

    if (!tabs.length) {
      return;
    }

    section.dataset.landingB2bProfessionalTabsInitialized = 'true';

    tabs.forEach((tab, index) => {
      tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');

      tab.addEventListener('click', () => {
        activateTab(section, tab);
      });

      tab.addEventListener('keydown', (event) => {
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          tabs[nextIndex].focus();
          activateTab(section, tabs[nextIndex]);
        }
      });

      if (index !== 0 && !tab.classList.contains('is-active')) {
        tab.setAttribute('tabindex', '-1');
      }
    });
  };

  const initAllSections = () => {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(sectionSelector);

    if (section) {
      initSection(section);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const section = block.closest(sectionSelector);

    if (!section) {
      return;
    }

    const panel = block.matches(panelSelector) ? block : block.closest(panelSelector);

    if (!panel) {
      return;
    }

    const tab = section.querySelector(`[aria-controls="${panel.id}"]`);

    if (tab) {
      activateTab(section, tab);
    }
  });
})();
